import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { SharedServices } from '../../../../../../services/shared.services'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl, getImageStatusUrl, getThumbnail } from '../../../../../../../helper/common'
import { downloadFile } from '../../../../../../../helper/download.helper'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import * as $ from 'jquery'


@Component({
    selector: 'app-modal-client-detail-top-registraion-movie',
    templateUrl: './modal-client-detail-registraion-movie.component.html',
    styleUrls: [
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registraion-movie.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalClientDetailRegistraionMovieComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    option_RegistrationMovie = 'active'
    TabRegistrationMovieClass
    status: Boolean = false
    arrRegistrationMovie: any[] = []
    statusImage: String = ''

    arrTabRegistrationOther = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]
    option_Registration: String = 'active'
    senMax: any = 100
    max: any = 5

    arrAllMovie: any[] = []
    jsonMovie: any = {}

    index: any
    arrShowStatus: any[] = []
    tabName: any = 'movie-all'
    uploadImageForm: FormGroup
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0

    arrImage: any[] = []
    emitTabName: any = {}
    emitArrAll: any = {}
    animationDuration: any

    arrLoading: any[] = []

    arrDownloadFile: any[] = ['', '', '', '', '', '']
    arrStyle: any[] = [{}, {}, {}, {}, {}, {}]
    isEmptyArray: Boolean = false
    resourceUrl = 'resource'
    countRecrond
    tabUploadImage: any
    ValueAssignOneDistance: any = 0

    getInfoIndex = undefined
    page = 'registration'
    unscrPage
    unscrAllArrClientTop
    unscrIndex
    urlThumbail = ''

    constructor(private _sharedService: SharedServices,
        private authData: AuthService,
        private restApi: RestServices,
        private formBuider: FormBuilder,
        private modalService: ModalService,
        private clientTopServices: ClientTopServices,
        public matrixServices: MatrixServices) {
        this.option_RegistrationMovie = 'active'
        this.TabRegistrationMovieClass = 'option_0'
    }

    ngOnInit() {
        this.arrLoading = [true, true, true, true, true, true]
        this.uploadImageForm = this.formBuider.group({
            requests: new FormArray([
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
            ]),
        })
        // this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
        const infoTabName: any = this.clientTopServices.functReturnTabName()
        if (infoTabName != null && infoTabName['tabName'] != undefined) {
            this.tabName = infoTabName['tabName']
        } else {
            this.tabName = 'movie-all'
        }
        const tmpStr: String = this.tabName
        if (tmpStr.includes('movie')) {
            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            
            this.getArrClientTop()
            // });
        }
        // });


        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        this.getStyle()
        this.resizeUser()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {

            if (status != null && status['status'] != undefined) {
                const tmp: any = status['status']
                if (tmp == 'in') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 500) / 2
                        this.width = this.height * 3 / 2
                    } else {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 500) / 2
                        this.width = this.height * 3 / 2
                    }
                } else {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 300) / 2
                        this.width = this.height * 3 / 2
                    }
                }
            }
        })
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    onStartUpload(event) {
        let listUpload: any[] = event.listUpload
        this.animationDuration = event.animationDuration
        const arrLenghtImageFile = event.arrLenghtImageFile
        for (let index = 0; index < listUpload.length; index++) {
            if (listUpload[index] && arrLenghtImageFile > index) {

                this.arrShowStatus[event.item] = true
                this.arrLoading[event.item] = true
                this.tabUploadImage = this.TabRegistrationMovieClass
            }
        }
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'registration') {
                this.index = infoIndex['index']
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('movie') && this.arrAllMovie.length > 0) {
                    //   const res: any = this.clientTopServices.returnArrAll();
                    this.max = this.arrAllMovie.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.index * this.ValueAssignOneDistance
                    } else {
                        this.valChange = 0
                    }
                    this.arrLoading = [false, false, false, false, false, false]
                    if (this.arrAllMovie[this.index] != undefined) {
                        this.jsonMovie = this.arrAllMovie[this.index]
                        this.initjsonMovie(this.arrAllMovie[this.index])
                        this.animationDuration = 300
                    }
                }
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            const tmpStr: String = this.tabName
            if (res != null && res['registration'] != undefined && res['registration'] && this.page == 'registration') {
                this.isEmptyArray = false
                this.arrAllMovie = res['registration']
                this.countRecrond = res['registration'].length
                if (this.countRecrond == 0) {
                    this.isEmptyArray = true
                    this.arrLoading = [false, false, false, false, false, false]
                }
                                
                if (tmpStr.includes('movie') && this.getInfoIndex) {
                    if (this.arrAllMovie.length > 0) {
                        this.max = this.arrAllMovie.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }
                        this.arrLoading = [false, false, false, false, false, false]
                        if (this.arrAllMovie[this.index] != undefined) {
                            this.jsonMovie = this.arrAllMovie[this.index]
                            this.initjsonMovie(this.arrAllMovie[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            } else {               
                this.countRecrond = 0
                this.isEmptyArray = true
                this.arrLoading = [false, false, false, false, false, false]
                this.arrRegistrationMovie = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrRegistrationMovie)
            }
        })
    }

    // isEmptyArr() {
    //   this.clientTopServices.changeEmiitedIsCreated$.subscribe(create => {
    //     if (create != null && create['create'] != undefined) {
    //       const tab: any = create['tabName'];

    //       if (tab == this.tabName) {
    //         this.isEmptyArray = true;
    //         this.getArrClientTop();
    //       }
    //     }
    //   });
    // }

    // refresh() {
    //   this.clientTopServices.changeEmittedrefreshArr$.subscribe(refresh => {
    //     if (refresh != null && refresh['refresh'] != undefined) {
    //       const tab: any = refresh['tabName'];
    //       if (refresh['refresh'] == true && this.tabName == tab) {
    //         this.callApiInfoTopClient();
    //       }
    //     }
    //   });
    // }

    getArrCopy() {
        this.clientTopServices.changeEmittedArrCopy$.subscribe(arCopy => {
            if (arCopy != null && arCopy['onCut'] != undefined) {
                if (arCopy['onCut'] == 'cut') {
                    const tab = arCopy['tabName']
                    if (this.tabName == tab) {
                        this.arrRegistrationMovie = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationMovie)
                        this.jsonMovie[this.tabName] = this.arrRegistrationMovie
                        this.arrAllMovie[this.index] = this.jsonMovie
                        const arrCopy: any[] = arCopy['arrCopy']
                        const tmp: any = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                        const jsonTmp: any = {}
                        jsonTmp['id'] = tmp
                        if (arrCopy[0]['id'] != '') {
                            switch (this.tabName) {
                                case 'movie-1':
                                    if (tmp != '') {
                                        this.jsonMovie['movie-all'][0] = jsonTmp
                                    }
                                    break
                                case 'movie-2':
                                    if (tmp != '') {
                                        this.jsonMovie['movie-all'][1] = jsonTmp
                                    }
                                    break
                                case 'movie-3':
                                    if (tmp != '') {
                                        this.jsonMovie['movie-all'][2] = jsonTmp
                                    }
                                    break
                                case 'movie-4':
                                    if (tmp != '') {
                                        this.jsonMovie['movie-all'][3] = jsonTmp
                                    }
                                    break
                                case 'movie-5':
                                    if (tmp != '') {
                                        this.jsonMovie['movie-all'][4] = jsonTmp
                                    }
                                    break
                                case 'movie-6':
                                    if (tmp != '') {
                                        this.jsonMovie['movie-all'][5] = jsonTmp
                                    }
                                    break
                                case 'movie-all':
                                    arrCopy.forEach((el, i) => {
                                        switch (i) {
                                            case 0:
                                                this.jsonMovie['movie-1'][0] = jsonTmp
                                                break
                                            case 1:
                                                this.jsonMovie['movie-2'][0] = jsonTmp
                                                break
                                            case 2:
                                                this.jsonMovie['movie-3'][0] = jsonTmp
                                                break
                                            case 3:
                                                this.jsonMovie['movie-4'][0] = jsonTmp
                                                break
                                            case 4:
                                                this.jsonMovie['movie-5'][0] = jsonTmp
                                                break
                                            case 5:
                                                this.jsonMovie['movie-6'][0] = jsonTmp
                                                break
                                            default:
                                                break
                                        }
                                    })
                                    break
                                default:
                                    break
                            }
                            this.arrAllMovie[this.index] = this.jsonMovie
                        }
                    }
                }
            }
        })
    }

    getStyle() {
        this.clientTopServices.changeEmittedStyle$.subscribe(style => {
            if (style != null && style['style'] != undefined) {
                const tab: any = style['tabName']
                if (tab == this.tabName) {
                    this.arrStyle = style['style']
                    if (this.arrStyle.length > 0) {
                        this.arrRegistrationMovie = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationMovie)
                        this.jsonMovie[this.tabName] = this.arrRegistrationMovie
                        this.arrAllMovie[this.index] = this.jsonMovie
                        this.emitArrAll['registration'] = this.arrAllMovie
                        this.emitArrAll['checkChange'] = true
                        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                    } else {
                        const arrCopy: any[] = style['arrCopy']
                        this.arrRegistrationMovie = arrCopy
                        arrCopy.forEach((el, i) => {
                            if (el['id'] != '') {
                                setTimeout(function () {
                                    const video: any = document.getElementById('video' + i)
                                    if (video != undefined && video.paused) {
                                        video.play()
                                    }
                                }, 1000)
                                setTimeout(function () {
                                    const video: any = document.getElementById('video' + i)
                                    if (video != undefined && video.played) {
                                        video.pause()
                                        video.currentTime = 0
                                    }
                                }, 1500)
                            }
                        })
                        this.getShowStatus(this.arrRegistrationMovie)
                        this.jsonMovie[this.tabName] = this.arrRegistrationMovie
                        this.arrAllMovie[this.index] = this.jsonMovie
                    }
                }
            } else {
                this.arrStyle = [{}, {}, {}, {}, {}, {}]
            }
        })
    }

    // getValueSlider() {
    //   this.clientTopServices.changeEmittedValueSlider$.subscribe(res => {
    //     if (res != null && res['sliderClientTop'] != undefined) {
    //       this.valChange = res['sliderClientTop'];
    //     }
    //   });
    // }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            // if (this.arrAllMovie[this.index] != undefined) {
            //     this.jsonMovie = this.arrAllMovie[this.index];
            //     this.initjsonMovie(this.jsonMovie);
            //     this.arrRegistrationMovie = this.jsonMovie[this.tabName];
            // }
            // this.valChange = assign;
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.valChange = 0
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(0)
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
    }

    initjsonMovie(json) {
        this.jsonMovie['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.getArrRegistrationMovie(this.jsonMovie)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.arrImage = []
        this.arrDownloadFile = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    const url = el['id']
                    const urlDownload: any = getImageStatusUrl(el['id'])
                    this.arrImage.push(url)
                    this.arrDownloadFile.push(urlDownload)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrDownloadFile.push(undefined)
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
            })
        }
    }

    getArrRegistrationMovie(arrTooth) {
        if (arrTooth[this.tabName].length) {
            this.arrRegistrationMovie = arrTooth[this.tabName]
        } else {
            this.arrRegistrationMovie = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        }
        this.getShowStatus(this.arrRegistrationMovie)

        if (this.arrRegistrationMovie.length) {
            this.arrRegistrationMovie.forEach((el, i) => {
                if (el != undefined && el['id'] != '') {
                    setTimeout(function () {
                        const video: any = document.getElementById('video' + i)
                        if (video != undefined && video.paused) {
                            video.play()
                        }
                    }, 1000)
                    setTimeout(function () {
                        const video: any = document.getElementById('video' + i)
                        if (video != undefined && video.played) {
                            video.pause()
                            video.currentTime = 0
                        }
                    }, 1050)
                }
            })
        }
    }

    swapArrImage(index, nextIndex) {
        const tmp = this.arrImage[index]
        const swapTmp = this.arrImage[nextIndex]
        this.arrImage.splice(index, 1, swapTmp)
        this.arrImage.splice(nextIndex, 1, tmp)
    }


    swapArr(index, nextIndex) {
        const tmp = this.arrRegistrationMovie[index]
        const tmpRight = this.arrRegistrationMovie[nextIndex]
        this.arrRegistrationMovie.splice(index, 1, tmpRight)
        this.arrRegistrationMovie.splice(nextIndex, 1, tmp)
        this.getShowStatus(this.arrRegistrationMovie)
        switch (this.TabRegistrationMovieClass) {
            case 'option_0':
                this.jsonMovie['movie-all'] = this.arrRegistrationMovie
                let i: any
                let left: any
                let right: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'movie-1'
                        right = 'movie-2'
                        break
                    case 2:
                        left = 'movie-1'
                        i = 'movie-2'
                        right = 'movie-3'
                        break
                    case 3:
                        left = 'movie-2'
                        i = 'movie-3'
                        right = 'movie-4'
                        break
                    case 4:
                        left = 'movie-3'
                        i = 'movie-4'
                        right = 'movie-5'
                        break
                    case 5:
                        left = 'movie-4'
                        i = 'movie-5'
                        right = 'movie-6'
                        break
                    case 6:
                        left = 'movie-5'
                        i = 'movie-6'
                        break
                }
                if (index > nextIndex) {
                    this.jsonMovie[left][0] = tmp
                    this.jsonMovie[i][0] = tmpRight
                } else {
                    this.jsonMovie[i][0] = tmpRight
                    this.jsonMovie[right][0] = tmp
                }
                break
            case 'option_1':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonMovie['movie-all'][0] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonMovie['movie-all'][0] = tmp3
                }
                this.jsonMovie['movie-1'] = this.arrRegistrationMovie
                break
            case 'option_2':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonMovie['movie-all'][1] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonMovie['movie-all'][1] = tmp3
                }
                this.jsonMovie['movie-2'] = this.arrRegistrationMovie
                break
            case 'option_3':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonMovie['movie-all'][2] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonMovie['movie-all'][2] = tmp3
                }
                this.jsonMovie['movie-3'] = this.arrRegistrationMovie
                break
            case 'option_4':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonMovie['movie-all'][3] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonMovie['movie-all'][3] = tmp3
                }
                this.jsonMovie['movie-4'] = this.arrRegistrationMovie
                break
            case 'option_5':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonMovie['movie-all'][4] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonMovie['movie-all'][4] = tmp3
                }
                this.jsonMovie['movie-5'] = this.arrRegistrationMovie
                break
            case 'option_6':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonMovie['movie-all'][5] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonMovie['movie-all'][5] = tmp3
                }
                this.jsonMovie['movie-6'] = this.arrRegistrationMovie
                break
            default:
                break
        }
        this.arrAllMovie[this.index] = this.jsonMovie
        this.emitArrAll['registration'] = this.arrAllMovie
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
    }

    actionVideo(index) {
        const video: any = document.getElementById('video' + index)
        if (video != undefined && video.paused) {
            video.play()
        } else if (video != undefined && video.played) {
            video.pause()
        }
    }


    moveRight(index) {
        const nextIndex: any = index + 1
        this.swapArr(index, nextIndex)
    }

    moveLeft(index) {
        const nextIndex: any = index - 1
        this.swapArr(index, nextIndex)
    }

    onDeleteImage(index) {
        const tmpNone: any = {}
        tmpNone['id'] = ''
        this.arrRegistrationMovie[index] = tmpNone
        switch (this.TabRegistrationMovieClass) {
            case 'option_0':
                this.jsonMovie['movie-all'] = this.arrRegistrationMovie
                const countIndex = index + 1
                const i: any = 'movie-' + countIndex
                const tmp: any = {}
                tmp['id'] = ''
                this.jsonMovie[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonMovie['movie-all'][0] = tmp1
                }
                this.jsonMovie['movie-1'] = this.arrRegistrationMovie
                break
            case 'option_2':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonMovie['movie-all'][1] = tmp1
                }
                this.jsonMovie['movie-2'] = this.arrRegistrationMovie
                break
            case 'option_3':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonMovie['movie-all'][2] = tmp1
                }
                this.jsonMovie['movie-3'] = this.arrRegistrationMovie
                break
            case 'option_4':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonMovie['movie-all'][3] = tmp1
                }
                this.jsonMovie['movie-4'] = this.arrRegistrationMovie
                break
            case 'option_5':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonMovie['movie-all'][4] = tmp1
                }
                this.jsonMovie['movie-5'] = this.arrRegistrationMovie
                break
            case 'option_6':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonMovie['movie-all'][5] = tmp1
                }
                this.jsonMovie['movie-6'] = this.arrRegistrationMovie
                break
            default:
                break
        }
        this.uploadImageForm.reset()
        this.arrAllMovie[this.index] = this.jsonMovie
        this.emitArrAll['registration'] = this.arrAllMovie
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationMovie)
    }

    toggleTabRegistrationMovieItem(id, event) {
        this.uploadImageForm.reset()
        this.TabRegistrationMovieClass = id
        this.arrLoading = [false, false, false, false, false, false]
        switch (id) {
            case 'option_0':
                this.tabName = 'movie-all'
                break
            case 'option_1':
                this.tabName = 'movie-1'
                break
            case 'option_2':
                this.tabName = 'movie-2'
                break
            case 'option_3':
                this.tabName = 'movie-3'
                break
            case 'option_4':
                this.tabName = 'movie-4'
                break
            case 'option_5':
                this.tabName = 'movie-5'
                break
            case 'option_6':
                this.tabName = 'movie-6'
                break
            default:
                break
        }
        this.tabUploadImage = undefined
        this.emitTabName['tabName'] = this.tabName
        this.arrRegistrationMovie = this.jsonMovie[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrRegistrationMovie)
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrRegistrationMovie && this.arrRegistrationMovie.length > 0) {
                const tmp: any = this.arrRegistrationMovie[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    setArrClientTop(data, index, idImage) {
        switch (this.tabUploadImage) {
            case 'option_0':
                this.jsonMovie['movie-all'] = data
                const countIndex: any = index + 1
                const i: any = 'movie-' + countIndex
                this.jsonMovie[i][0] = idImage
                break
            case 'option_1':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonMovie['movie-all'][0] = tmp3
                }
                this.jsonMovie['movie-1'] = data
                break
            case 'option_2':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonMovie['movie-all'][1] = tmp3
                }
                this.jsonMovie['movie-2'] = data
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonMovie['movie-all'][2] = tmp3
                }
                this.jsonMovie['movie-3'] = data
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonMovie['movie-all'][3] = tmp3
                }
                this.jsonMovie['movie-4'] = data
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonMovie['movie-all'][4] = tmp3
                }
                this.jsonMovie['movie-5'] = data
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonMovie['movie-all'][5] = tmp3
                }
                this.jsonMovie['movie-6'] = data
                break
            default:
                break
        }
        this.arrAllMovie[this.index] = this.jsonMovie
        this.emitArrAll['registration'] = this.arrAllMovie
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
    }

    uploadFileEnd(event) {
        const index = event.item
        this.tabUploadImage = this.TabRegistrationMovieClass
        const arrUploadImage: any[] = this.arrRegistrationMovie

        this.urlThumbail = getThumbnail(event.success['hash'])
        const tmp: any = {}
        tmp['id'] = event.success['hash']
        arrUploadImage[index] = tmp
        this.arrLoading[index] = false
        this.setArrClientTop(arrUploadImage, index, tmp)
        const video: any = document.getElementById('video' + index)
        setTimeout(function () {
            if (video != undefined && video.paused) {
                video.play()
            }
        }, 1000)
        setTimeout(function () {
            if (video != undefined && video.played) {
                video.pause()
                video.currentTime = 0
            }
        }, 1500)
        this.resetFile(index)
    }

    onUploadError() {
        this.uploadImageForm.reset()
    }

    handleFileInput(files: FileList, index, event) {
        if (event.target.files && event.target.files[0]) {
            this.tabUploadImage = this.TabRegistrationMovieClass
            const arrUploadImage: any[] = this.arrRegistrationMovie
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            this.arrDownloadFile[index] = event.target.files[0]
            const excrptFile: any = 'video'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 2800
                this.arrLoading[index] = true
                reader.onload = (event: any) => {
                    this.arrShowStatus[index] = true
                    this.getUrlImage(0, event.target.result)
                }
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            this.urlThumbail = getThumbnail(success['hash'])
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            arrUploadImage[index] = tmp
                            this.arrLoading[index] = false
                            this.setArrClientTop(arrUploadImage, index, tmp)
                            const video: any = document.getElementById('video' + index)
                            setTimeout(function () {
                                if (video != undefined && video.paused) {
                                    video.play()
                                }
                            }, 1000)
                            setTimeout(function () {
                                if (video != undefined && video.played) {
                                    video.pause()
                                    video.currentTime = 0
                                }
                            }, 1500)
                            this.resetFile(index)
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }

    resetFile(item) {
        $('#fileUpload_' + item).val('');
    }

    downloadVideo(index) {
        const a: any = document.getElementById('download')
        const tmp: any = this.arrDownloadFile[index]
        
        if (typeof tmp == 'string') {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_get(tmp, tokenReNew).subscribe(res => {
                    this.arrLoading[index] = true
                    this.animationDuration = 4000
                    const _thi = this

                    downloadFile(res['url'], _thi.arrRegistrationMovie[index]['id'], () => {
                        this.arrLoading[index] = false
                    })

                })
            })
        } else {
            const file: any = new Blob([this.arrDownloadFile[index]], { type: 'video/mp4' })
            const fileName: any = this.arrDownloadFile[index]['name']
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file, fileName)
            } else { // Others
                const b = document.createElement('a'),
                    url = URL.createObjectURL(file)
                b.href = url
                b.download = fileName
                document.body.appendChild(b)
                b.click()
                setTimeout(function () {
                    document.body.removeChild(b)
                    window.URL.revokeObjectURL(url)
                }, 10)
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationMovie/modal-client-detail-registraion-movie.component.ts